











































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { ifValid, processError } from "@/utils/ComponentUtils";
import LandingInput from "@/components/landing/common/LandingInput.vue";
import Application from "@/state/Application";
import RouteNames from "@/router/RouteNames";

const AppModule = namespace("App");
const Auth = namespace("Auth");

@Component({
  components: { LandingInput }
})
export default class Login extends Vue {
  @Auth.Action
  private login!: (data: any) => Promise<any>;

  private user = { email: "", password: "" };

  handleLogin(): void {
    ifValid(this, () => {
      Application.startLoading();
      if (this.user.email && this.user.password) {
        this.login(this.user).then(
          (data) => {
            Application.stopLoading();
            this.afterLogin();
          },
          (error) => {
            Application.stopLoading();
            processError(error, this);
          }
        );
      }
    });
  }

  afterLogin(): void {
    if (localStorage.getItem("backUrl")) {
      const backUrl = localStorage.getItem("backUrl") as string;
      localStorage.removeItem("backUrl");
      window.location.href = backUrl;
    } else {
      this.$router.push({ name: RouteNames.HOME });
    }
  }

  goRestorePassword(): void {
    this.$emit('toggleMode', 'RestorePassword');
  }

  goBecomeClient(): void {
    this.$emit('toggleMode', 'BecomeClient');
  }
}
